var _circle, _circle2, _circle3, _circle4, _rect, _rect2, _path, _path2, _path3, _g, _path4, _path5, _circle5, _circle6, _g2, _circle7, _circle8, _g3, _circle9, _circle10, _g4, _circle11, _circle12, _g5, _circle13, _circle14, _g6, _circle15, _circle16, _g7, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYelloeflags(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 310,
    height: 50,
    viewBox: "0 0 310 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#FBB723"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 25.5,
    r: 21.0523,
    fill: "url(#pattern0)",
    stroke: "#2C292A",
    strokeWidth: 0.895485
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 62,
    cy: 25,
    r: 25,
    fill: "#FBB723"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5403_10375",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 40,
    y: 3,
    width: 44,
    height: 44
  }, _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 61.7843,
    cy: 24.784,
    r: 21.7841,
    transform: "rotate(180 61.7843 24.784)",
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5403_10375)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 3,
    width: 43.5682,
    height: 43.5682,
    fill: "#A00009"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 83.5684,
    y: 13.8921,
    width: 21.7841,
    height: 43.5682,
    transform: "rotate(90 83.5684 13.8921)",
    fill: "#F1B434"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.6756 14.9006H54.8858V15.7074L56.0961 15.7074V16.9177H54.8858V18.0483C55.2418 17.8424 55.6552 17.7245 56.0961 17.7245C57.4328 17.7245 58.5165 18.8082 58.5165 20.1449C58.5165 20.8618 58.2049 21.5059 57.7096 21.9491V22.9688H50.8517V21.949C50.3565 21.5058 50.0449 20.8618 50.0449 20.1449C50.0449 18.8082 51.1286 17.7245 52.4654 17.7245C52.9062 17.7245 53.3196 17.8424 53.6756 18.0483V16.9177H52.4654V15.7074L53.6756 15.7074V14.9006ZM54.2807 18.5439L54.2695 18.5313H54.2919L54.2807 18.5439ZM54.2695 21.7586L54.2807 21.746L54.2919 21.7586H54.2695Z",
    fill: "#E26E00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.834 22.9688L59.726 22.9687L59.726 28.9121C59.726 31.3044 58.2739 33.4573 56.0558 34.3535V34.3535C54.9167 34.8138 53.6434 34.8138 52.5042 34.3535V34.3535C50.2861 33.4573 48.834 31.3044 48.834 28.9121L48.834 22.9688Z",
    fill: "#F5F7F8"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_5403_10375",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 48,
    y: 22,
    width: 12,
    height: 13
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.834 22.9688H59.726V28.9121C59.726 31.3044 58.2739 33.4573 56.0558 34.3535V34.3535C54.9167 34.8138 53.6434 34.8138 52.5042 34.3535V34.3535C50.2861 33.4573 48.834 31.3044 48.834 28.9121V22.9688Z",
    fill: "#F5F7F8"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_5403_10375)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 48.834,
    y: 22.9688,
    width: 5.44602,
    height: 6.05114,
    fill: "#DD2033"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.834,
    y: 29.0198,
    width: 5.44602,
    height: 6.05114,
    fill: "#E26E00"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54.2812,
    y: 29.0198,
    width: 5.44602,
    height: 6.05114,
    fill: "#DD2033"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M60.9364 22.9688H62.7517V34.4659H60.9364V22.9688Z",
    fill: "#F5F7F8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8086 22.9688H47.6239V34.4659H45.8086V22.9688Z",
    fill: "#F5F7F8"
  }))), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 99,
    cy: 25,
    r: 25,
    fill: "#FBB723"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_5403_10375",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 77,
    y: 3,
    width: 44,
    height: 44
  }, _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 98.7841,
    cy: 24.7841,
    r: 21.7841,
    fill: "#D9D9D9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_5403_10375)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 77,
    y: 46.5681,
    width: 14.5227,
    height: 43.5682,
    transform: "rotate(-90 77 46.5681)",
    fill: "#DD2033"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77,
    y: 32.0454,
    width: 14.5227,
    height: 43.5682,
    transform: "rotate(-90 77 32.0454)",
    fill: "#004692"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77,
    y: 17.5227,
    width: 14.5227,
    height: 43.5682,
    transform: "rotate(-90 77 17.5227)",
    fill: "#F5F7F8"
  }))), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 136,
    cy: 25,
    r: 25,
    fill: "#FBB723"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_5403_10375",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 114,
    y: 3,
    width: 44,
    height: 44
  }, _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 135.784,
    cy: 24.7841,
    r: 21.7841,
    fill: "#D9D9D9"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_5403_10375)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 114,
    y: 46.5681,
    width: 12.1023,
    height: 43.5682,
    transform: "rotate(-90 114 46.5681)",
    fill: "#009B77"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114,
    y: 34.4658,
    width: 19.3636,
    height: 43.5682,
    transform: "rotate(-90 114 34.4658)",
    fill: "#F5F7F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114,
    y: 15.1023,
    width: 12.1023,
    height: 43.5682,
    transform: "rotate(-90 114 15.1023)",
    fill: "#FF9E42"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M143.651 24.7842C143.651 29.1287 140.129 32.6507 135.784 32.6507C131.44 32.6507 127.918 29.1287 127.918 24.7842C127.918 20.4397 131.44 16.9177 135.784 16.9177C140.129 16.9177 143.651 20.4397 143.651 24.7842ZM137.282 30.0218C136.806 30.1576 136.304 30.2302 135.784 30.2302C135.265 30.2302 134.763 30.1576 134.287 30.0218L135.784 28.3429L137.282 30.0218ZM137.5 29.9544C138.533 29.6118 139.428 28.9686 140.083 28.1285L137.774 27.6641L137.5 29.9544ZM140.14 28.0541C140.825 27.1435 141.23 26.0113 141.23 24.7842C141.23 24.7842 141.23 24.7842 141.23 24.7842C141.23 23.5572 140.825 22.4249 140.14 21.5144L139.005 23.6839L141.23 24.7842L139.005 25.8846L140.14 28.0541ZM140.083 21.4399C139.428 20.5998 138.533 19.9566 137.501 19.6141L137.774 21.9043L140.083 21.4399ZM137.282 19.5466L135.784 21.2255L134.287 19.5466C134.763 19.4108 135.265 19.3382 135.784 19.3382C136.304 19.3382 136.806 19.4109 137.282 19.5466ZM134.068 19.614C133.036 19.9566 132.14 20.5998 131.486 21.4399L133.795 21.9043L134.068 19.614ZM131.429 21.5144C130.744 22.4249 130.338 23.5572 130.338 24.7842C130.338 24.7841 130.338 24.7842 130.338 24.7842C130.338 26.0112 130.744 27.1434 131.429 28.054L132.564 25.8845L130.338 24.7842L132.564 23.6838L131.429 21.5144ZM131.486 28.1285C132.14 28.9686 133.036 29.6118 134.068 29.9544L133.795 27.6641L131.486 28.1285Z",
    fill: "#004692"
  }))), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 173,
    cy: 25,
    r: 25,
    fill: "#FBB723"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_5403_10375",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 151,
    y: 3,
    width: 44,
    height: 44
  }, _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 172.784,
    cy: 24.7841,
    r: 21.7841,
    fill: "#D9D9D9"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_5403_10375)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 151,
    y: 46.5681,
    width: 13.3125,
    height: 43.5682,
    transform: "rotate(-90 151 46.5681)",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 151,
    y: 33.2556,
    width: 16.9432,
    height: 43.5682,
    transform: "rotate(-90 151 33.2556)",
    fill: "#F5F7F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 151,
    y: 16.3125,
    width: 13.3125,
    height: 43.5682,
    transform: "rotate(-90 151 16.3125)",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151 8.44604V41.1222H152.21L159.472 35.6762L173.994 24.7841L159.472 13.8921L152.21 8.44604H151Z",
    fill: "#D80027"
  }))), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 211,
    cy: 25,
    r: 25,
    fill: "#FBB723"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_5403_10375",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 189,
    y: 3,
    width: 44,
    height: 44
  }, _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.7841,
    cy: 21.7841,
    r: 21.7841,
    transform: "matrix(1 0 0 -1 189 46.5681)",
    fill: "#D9D9D9"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_5403_10375)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.5227,
    height: 43.5682,
    transform: "matrix(1 0 0 -1 189 46.5681)",
    fill: "#004692"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 14.5227,
    height: 43.5682,
    transform: "matrix(1 0 0 -1 203.523 46.5681)",
    fill: "#F5F7F8"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 14.5227,
    height: 43.5682,
    transform: "matrix(1 0 0 -1 218.045 46.5681)",
    fill: "#DD2033"
  }))), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 25,
    r: 25,
    fill: "#FBB723"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_5403_10375",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 228,
    y: 3,
    width: 44,
    height: 44
  }, _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 249.784,
    cy: 24.7841,
    r: 21.7841,
    fill: "#D9D9D9"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_5403_10375)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 228,
    y: 3,
    width: 43.5682,
    height: 43.5682,
    fill: "#005B33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.675 19.2606L252.361 14.853L255.16 18.327L259.403 17.752L257.17 21.5228L259.106 25.575L254.841 24.1075L251.881 27.5109L251.532 23.0335L247.713 20.8843L251.675 19.2606Z",
    fill: "#F5F7F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.902 32.6506C253.075 32.6506 254.2 32.4545 255.246 32.0943C253.471 34.2798 250.762 35.6762 247.727 35.6762C242.38 35.6762 238.045 31.3415 238.045 25.9944C238.045 21.9707 240.499 18.5203 243.993 17.0588C242.692 18.6939 241.918 20.7437 241.918 22.9688C241.918 28.3159 246.388 32.6506 251.902 32.6506Z",
    fill: "#F5F7F8"
  }))), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 285,
    cy: 25,
    r: 25,
    fill: "#FBB723"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_5403_10375",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 263,
    y: 3,
    width: 44,
    height: 44
  }, _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 284.784,
    cy: 24.7841,
    r: 21.7841,
    fill: "#D9D9D9"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_5403_10375)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 263,
    y: 3,
    width: 43.5682,
    height: 43.5682,
    fill: "#008259"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.784 11.4717L302.938 24.7842L284.784 38.0967L266.631 24.7842L284.784 11.4717Z",
    fill: "#F1B434"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.087 33.2557C289.599 33.2557 293.256 29.4628 293.256 24.7841C293.256 20.1054 289.599 16.3125 285.087 16.3125C280.575 16.3125 276.918 20.1054 276.918 24.7841C276.918 29.4628 280.575 33.2557 285.087 33.2557Z",
    fill: "#004692"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.039 23.3171C278.075 23.0887 279.148 22.9687 280.245 22.9687C285.047 22.9687 289.384 25.2672 292.228 28.8992C292.783 27.8659 293.135 26.6997 293.23 25.4583C289.895 22.0487 285.308 19.9431 280.245 19.9431C279.593 19.9431 278.948 19.9781 278.313 20.0463C277.683 21.0131 277.24 22.1221 277.039 23.3171Z",
    fill: "#F5F7F8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_5403_10375",
    transform: "scale(0.00819672)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_5403_10375",
    width: 122,
    height: 122,
    xlinkHref: "data:image/png;base64,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"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYelloeflags);
export default __webpack_public_path__ + "static/media/Yelloeflags.c70f12241ac54c8fd999d67bd5b10127.svg";
export { ForwardRef as ReactComponent };